import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider, useLanguage } from "@/i18n/LanguageContext";
import { Header, Footer, FloatingWhatsApp } from "@/components/Chrome";
import Home from "@/pages/Home";
import { TopicsOverview, TopicDetail } from "@/pages/Topics";
import { MethodsOverview, MethodDetail } from "@/pages/Methods";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Faq from "@/pages/Faq";
import Feedback from "@/pages/Feedback";
import Contact from "@/pages/Contact";
import { Impressum, Datenschutz } from "@/pages/Legal";
import { CookieBanner } from "@/components/CookieBanner";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const SkipLink = () => {
  const { t } = useLanguage();
  return (
    <a href="#main-content" className="skip-link" data-testid="skip-to-content-link">
      {t.common.skipToContent}
    </a>
  );
};

const Shell = () => {
  useLenis();
  return (
    <>
      <SkipLink />
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/themen" element={<TopicsOverview />} />
        <Route path="/themen/:slug" element={<TopicDetail />} />
        <Route path="/arbeitsweise" element={<MethodsOverview />} />
        <Route path="/arbeitsweise/:slug" element={<MethodDetail />} />
        <Route path="/ueber-mich" element={<About />} />
        <Route path="/preise" element={<Pricing />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <CookieBanner />
      <FloatingWhatsApp />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
